var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmileyNeutral = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "smiley_neutral_svg__Plus",
  x: 0,
  y: 0,
  viewBox: "0 0 24 24"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".smiley_neutral_svg__st1{fill:$colour-neutral-grey-900}")), /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0",
  style: {
    fill: "#ffdb00"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.3 10.6c.4 0 .7-.1.9-.4.2-.2.4-.5.4-.9C9.6 8.6 9 8 8.3 8S7 8.6 7 9.3c0 .2 0 .3.1.5.2.4.6.8 1.2.8M16.9 9.8c.1-.2.1-.3.1-.5 0-.7-.6-1.3-1.3-1.3s-1.3.6-1.3 1.3c0 .4.1.7.4.9.2.2.6.4.9.4.5 0 1-.4 1.2-.8M9 16h6v1.3H9z",
  className: "smiley_neutral_svg__st1"
})));
export { SvgSmileyNeutral as ReactComponent };
export default __webpack_public_path__ + "smiley_neutral.svg";